import type { ResourceActivity } from '@/types';

/** Standalone labels omit the trailing preposition used before a resource identity in sentences. */
export const getResourceActivityActionLabel = (activity: Pick<ResourceActivity, 'action' | 'eventType'>): string => {
    const label = (activity.action || activity.eventType).trim().replace(/ (?:of|on|for)$/, '');
    return label.charAt(0).toUpperCase() + label.slice(1);
};
